/**
 * Camp Sticky Sidebar
 * Shows/hides based on #sidebar visibility
 */
;(function () {
  const stickySidebar = document.querySelector('.rd-camp-sticky-sidebar')
  const elementToObserve = document.querySelector('#camp-subscribe-form') || stickySidebar.previousElementSibling

  if (!stickySidebar || !elementToObserve) return

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        // Show sticky sidebar only when elementToObserve has scrolled above viewport
        // (element is out of view at the top). Hide when element is visible or below viewport.
        const isAboveViewport = !entry.isIntersecting && entry.boundingClientRect.top < 0
        stickySidebar.dataset.visible = isAboveViewport ? 'true' : 'false'
      })
    },
    {
      threshold: 0,
      rootMargin: '0px',
    },
  )

  observer.observe(elementToObserve)
})()
